import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface BannerState {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
}

export const useBannerStore = create<BannerState>()(
  devtools(
    (set) => ({
      isVisible: false,
      setIsVisible: (isVisible: boolean) => set(() => ({ isVisible })),
    }),
    {
      name: 'Banner Store',
      enabled: import.meta.env.DEV,
    },
  ),
);
